import { useEffect } from "react";
import { useSettings } from ".";

export function useDocumentDirection(): void {
    const { settings } = useSettings();

    useEffect(() => {
        document.dir = settings.direction;
    }, [settings.direction]);
}
